/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_DisabledInputs */

const cs_settings_profile_2fa_disabled = /** @type {(inputs: Settings_Profile_2fa_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není zapnuto`)
};

const en_settings_profile_2fa_disabled = /** @type {(inputs: Settings_Profile_2fa_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enabled`)
};

/**
* | output |
* | --- |
* | "Not enabled" |
*
* @param {Settings_Profile_2fa_DisabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_disabled = /** @type {((inputs?: Settings_Profile_2fa_DisabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_DisabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_disabled(inputs)
	return cs_settings_profile_2fa_disabled(inputs)
});